/**
 * Created by hao.cheng on 2017/4/16.
 */
import React from 'react';
import axios from 'axios';
import { post } from '../../axios';
import {Col,Row, Form, Icon, Dropdown,Carousel,Menu ,Popover} from 'antd';
import { connect } from 'react-redux';
import {Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { fetchData, receiveData } from '@/action';
import BannerAnim, { Element } from 'rc-banner-anim';
import TweenOne from 'rc-tween-one';
import 'rc-banner-anim/assets/index.css';


import ptrk from '@/style/imgs/all/ptrk.png';
import banner1 from '@/style/imgs/all/banner1.png';
import banner2 from '@/style/imgs/all/banner2.png';
import banner3 from '@/style/imgs/all/banner3.png';
import banner4 from '@/style/imgs/all/banner4.png';
import ptrkbanner from '@/style/imgs/all/ptrkbanner.png';
import amount from '@/style/imgs/all/amount.png';
import zzpa from '@/style/imgs/all/zzpa.png';
import zzrs from '@/style/imgs/all/zzrs.png';
import acbx from '@/style/imgs/all/acbx.png';
import astp from '@/style/imgs/all/astp.png';
import phone from '@/style/imgs/all/phone.png';
import phone1 from '@/style/imgs/all/phone1.png';
import wx from '@/style/imgs/all/wx.png';
import wx1 from '@/style/imgs/all/wx1.png';
import xcx from '@/style/imgs/all/xcx.png';
import xcx1 from '@/style/imgs/all/xcx1.png';
import tel from '@/style/imgs/all/tel.png';
import tel1 from '@/style/imgs/all/tel1.png';
import lb from '@/style/imgs/all/lb.png';
import rb from '@/style/imgs/all/rb.png';
import logo from '@/style/imgs/all/logo.png';
import fw from '@/style/imgs/all/fw.png';
import rmbx from '@/style/imgs/all/rmbx.png';
import tpy from '@/style/imgs/all/tpy.png';
import zybx from '@/style/imgs/all/zybx.png';
import bc from '@/style/imgs/all/bc.png';
import bm from '@/style/imgs/all/bm.png';
import jljt from '@/style/imgs/all/jljt.png';
import cdd from '@/style/imgs/all/cdd.png';
import imgB from '@/style/imgs/all/imgB.png';
import ydjyewm from '@/style/imgs/all/yidian.png';
import feimaewm from '@/style/imgs/all/feima.png';
import xcxewm from '@/style/imgs/all/xcxewm.png';

const FormItem = Form.Item;
const BgElement = Element.BgElement;
const MenuItemGroup = Menu.ItemGroup;
const SubMenu = Menu.SubMenu;

class Login extends React.Component {
    state = {
        active:1,
        orderActive:"",
        title:"",
        index:0,
        bannerIndex:1,
        current:"login",
        showButton:true,
        imgList:[
            {src:"tc",img:require("@/style/imgs/all/tc.png"),title:"拖车救援"},
            {src:"dd",img:require("@/style/imgs/all/dd.png"),title:"搭电"},
            {src:"ht",img:require("@/style/imgs/all/ht.png"),title:"换胎"},
            {src:"sy",img:require("@/style/imgs/all/sy.png"),title:"送油"},
            {src:"ss",img:require("@/style/imgs/all/ss.png"),title:"送水"},
            {src:"ys",img:require("@/style/imgs/all/ys.png"),title:"钥匙"},
        ],
        imgListUse:[
            {src:"tc",img:require("@/style/imgs/all/tc.png"),title:"拖车救援"},
            {src:"dd",img:require("@/style/imgs/all/dd.png"),title:"搭电"},
            {src:"ht",img:require("@/style/imgs/all/ht.png"),title:"换胎"},
            {src:"sy",img:require("@/style/imgs/all/sy.png"),title:"送油"},
        ]
    };
    componentDidMount() {

    };
    componentWillMount() {
        const { receiveData } = this.props;
        receiveData(null, 'auth');
    }
    changeActive = (name) =>{
        const { history } = this.props;
        history.push("/feima/"+name)
    }
    turnlogin =()=>{
        const { history } = this.props;
        window.open("http://hd.feima666.com");
    }
    prevImg =()=>{
        if(this.state.index==2){
            let imgArry=this.state.imgListUse;
            imgArry.pop();
            imgArry.unshift(this.state.imgList[1])
            this.setState({
                imgListUse:imgArry,
                index:1
            })
        }else if(this.state.index==1){
            let imgArry=this.state.imgListUse;
            imgArry.pop();
            imgArry.unshift(this.state.imgList[0])
            this.setState({
                imgListUse:imgArry,
                index:0
            })
        }
    }
    nextImg =()=>{
        if(this.state.index==0){
            let imgArry=this.state.imgListUse;
            imgArry.shift();
            imgArry.push(this.state.imgList[4])
            this.setState({
                imgListUse:imgArry,
                index:1
            })
        }else if(this.state.index==1){
            let imgArry=this.state.imgListUse;
            imgArry.shift();
            imgArry.push(this.state.imgList[5])
            this.setState({
                imgListUse:imgArry,
                index:2
            })
        }
    }
    toggleHover =(e)=>{
        e.target.src=require("@/style/imgs/all/lb.png")
    }
    toggleLeave=(e)=>{
        e.target.src=require("@/style/imgs/all/rb.png")
    }
    appOver =(type)=>{
            let stateObj = {};
            stateObj[type]=true;
            this.setState(stateObj);
    }
    appOut =(type)=>{
        let stateObj = {};
        stateObj[type]=false;
        this.setState(stateObj);
    }
    imgChange = (from, to) =>{
        if(from==2){
            this.setState({
                showButton:true,
            })
        }else{
            this.setState({
                showButton:false,
            })
        }
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div style={{overflowY:"auto",width:"1912px"}}>
                <Col style={{height:44,background:"#333",overflow:"hidden"}}>
                    <Col style={{float:"left",marginLeft:350}}>
                        <img style={{marginTop:6}} src={logo} alt=""/>
                        <img style={{marginTop:16,marginLeft:30}} src={fw} alt=""/>
                    </Col>
                    <Col style={{float:"right",marginRight:373,fontSize:16,color:"#fff",lineHeight:"52px"}}>
                        24小时救援热线：400-070-9995 <span style={{marginLeft:20}}>开放平台</span>
                    </Col>
                </Col>
                <Col>
                    <Col style={{height:720,position:"relative"}}>
                        <Col style={{width:"100%",zIndex:1,position:"absolute",left:0,top:0,background:"rgba(255, 255, 255, 0.26)",paddingLeft:350,paddingRight:100,height:50}} >
                            <Row className="headMenu">
                                <Menu
                                    onClick={this.handleClick}
                                    selectedKeys={[this.state.current]}
                                    mode="horizontal"
                                    className="firstMenu"
                                    style={{height:50}}
                                >
                                    <Menu.Item style={{padding:0,marginRight:30}} key="login">
                                        <Link style={{fontSize:16,color:"#212121"}} to="/"  rel="noopener noreferrer">首页</Link>
                                    </Menu.Item>
                                    <Menu.Item style={{padding:0,marginRight:30}} key="gywm">
                                        <Link style={{fontSize:16,color:"#212121"}} to="/feima/gywm"  rel="noopener noreferrer">关于我们</Link>
                                    </Menu.Item>
                                    <Menu.Item style={{padding:0,marginRight:30}} key="cgal">
                                        <Link style={{fontSize:16,color:"#212121"}} to="/feima/cgal"  rel="noopener noreferrer">成功案例</Link>
                                    </Menu.Item>
                                    <Menu.Item style={{padding:0,marginRight:30}} key="xwzx">
                                        <Link style={{fontSize:16,color:"#212121"}} to="/feima/xwzx"  rel="noopener noreferrer">新闻中心</Link>
                                    </Menu.Item>
                                    <SubMenu className="jrwmMenu" style={{fontSize:16,color:"#212121",padding:0,marginRight:30}} title={<span className="submenu-title-wrapper">加入我们</span>}>
                                        <MenuItemGroup>
                                            <Menu.Item key="ptrk">
                                                <a href="http://hd.feima666.com" target="_blank"  rel="noopener noreferrer">平台入口</a>
                                            </Menu.Item>
                                            <Menu.Item key="zpxx">
                                                <Link to="/feima/zpxx"  rel="noopener noreferrer">招聘信息</Link>
                                            </Menu.Item>
                                        </MenuItemGroup>
                                    </SubMenu>
                                    <Menu.Item style={{padding:0,marginRight:30}} key="lxwm">
                                        <Link style={{fontSize:16,color:"#212121"}} to="/feima/lxwm"  rel="noopener noreferrer">联系我们</Link>
                                    </Menu.Item>
                                    <Menu.Item  style={{padding:0}} key="yjjy">
                                        <Link style={{fontSize:16,color:"#212121"}} to="/feima/yjjy"  rel="noopener noreferrer">一键救援</Link>
                                    </Menu.Item>
                                    <Col  style={{float:"right",cursor:"pointer",lineHeight:"20px",fontSize:16,marginRight:273,marginTop:-10}}>
                                        <Col style={{display:"inline-block"}}>
                                            <span className="turnLogin" onClick={this.turnlogin} style={{cursor:"pointer",padding:"5px 10px",color:"#fff",fontSize:16,width:94,height:36,marginRight:18,background:"#212121"}} >平台入口</span>
                                        </Col>
                                        <Col onMouseOver={()=>this.appOver("yidian")} onMouseOut={()=>this.appOut("yidian")} style={{display:"inline-block",color:this.state.yidian?"#d2a475":"#212121"}}>
                                            <Popover placement="bottom" content={<div style={{height:200,width:200}}><img src={ydjyewm} alt=""/></div>} title="扫描二维码下载">
                                                    <img style={{marginRight:10,color:"#d2a475"}} src={this.state.yidian?phone1:phone} alt=""/>下载一点APP
                                            </Popover>
                                        </Col>
                                    </Col>
                                </Menu>
                            </Row>

                        </Col>
                        <div style={{position:"relative"}}>
                            <span className="turnLogin" onClick={this.turnlogin} style={{textAlign:"center",display:this.state.showButton?"inline-block":"none",cursor:"pointer",zIndex:5,position:"absolute",left:347,top:274,padding:"5px 10px",color:"#212121",fontSize:16,width:94,height:36,background:"#fff"}}  >平台入口</span>
                            <Carousel beforeChange={this.imgChange} className="bannerImg" style={{width:"100%"}} autoplay>
                                <div> <img src={banner1} alt=""/></div>
                                <div><img src={banner2} alt=""/></div>
                                <div> <img src={banner3} alt=""/></div>
                            </Carousel>
                        </div>
                    </Col>
                    <Col style={{textAlign:"center"}}>
                        <Col style={{marginTop:68,fontSize:"30px",color:"#212121",fontWeight:"bold"}}>飞马救援服务</Col>
                        <Col style={{marginTop:18,fontSize:"16px",color:"#666666"}}>我们专注拖车救援行业，帮助您解决一路遇到的各种麻烦与困扰</Col>
                        <Col style={{margin:"0 auto",width:32,marginTop:28,borderBottom:"2px solid #d2a475"}}></Col>
                    </Col>
                    <Col style={{paddingTop:100,textAlign:"center",height:700}}>
                        <Col style={{marginTop:76,transform:"rotate(180deg)"}} md={4}>
                            <img onMouseEnter={this.toggleHover} onMouseLeave={this.toggleLeave} style={{cursor:"pointer"}} onClick={this.prevImg} src={rb} alt=""/>
                        </Col>
                        <Col md={16}>
                            <Row type="flex" justify="space-between">
                                {this.state.imgListUse.map((val,index)=>
                                    <Col className={val.src} style={{height:312,width:280,border:"1px solid rgb(245, 245, 245)"}} md={6}>
                                        <Col style={{marginTop:38}}>
                                            <div className="img" style={{width:110,height:110,display:"inline-block",background:`url(${val.img})`}}></div>
                                        </Col>
                                        <Col className="title" style={{fontSize:24,color:"#212121",marginTop:24}}>{val.title}</Col>
                                        <Col className="border" style={{margin:"0 auto",width:80,marginTop:16,borderBottom:"1px solid #d2a475"}}></Col>
                                        <Col className="content" style={{fontSize:14,color:"#666",marginTop:18}}>我们专注拖车救援行业，帮助您解决一路遇到的各种麻烦与困扰</Col>
                                    </Col>)}
                            </Row>

                        </Col>
                        <Col style={{marginTop:76}} md={4}>
                            <img onMouseEnter={this.toggleHover} onMouseLeave={this.toggleLeave} style={{cursor:"pointer"}} onClick={this.nextImg} src={rb} alt=""/>
                        </Col>
                    </Col>
                    <Col style={{height:260,backgroundImage:`url(${amount})`,textAlign:"center",paddingTop:96}}>
                        <Col offset={4} md={4}>
                            <Col style={{color:"#fff",fontSize:"28px"}}>10年</Col>
                            <Col style={{color:"#fff",fontSize:"16px"}}>扎根救援行业</Col>
                        </Col>
                        <Col md={4}>
                            <Col style={{color:"#fff",fontSize:"28px"}}>600万件</Col>
                            <Col style={{color:"#fff",fontSize:"16px"}}>累计救援人车数量</Col>
                        </Col>
                        <Col md={4}>
                            <Col style={{color:"#fff",fontSize:"28px"}}>2000家</Col>
                            <Col style={{color:"#fff",fontSize:"16px"}}>目前合作单位</Col>
                        </Col>
                        <Col  md={4}>
                            <Col style={{color:"#fff",fontSize:"28px"}}>146个</Col>
                            <Col style={{color:"#fff",fontSize:"16px"}}>救援覆盖省市</Col>
                        </Col>
                    </Col>
                    <Col style={{textAlign:"center",position:"relative"}}>
                        <Col style={{marginTop:120,fontSize:"30px",color:"#212121",fontWeight:"bold"}}>飞马救援伙伴</Col>
                        <div>
                            <Carousel className="logoImg" style={{width:"100%"}}  autoplay>
                                <Col>
                                    <Col>
                                        <img  src={rmbx} alt=""/>
                                        <img style={{background:"#f2f2f2"}} src={zzpa} alt=""/>
                                        <img  src={tpy} alt=""/>
                                    </Col>
                                    <Col>
                                        <img style={{background:"#f2f2f2"}} src={zzrs} alt=""/>
                                        <img src={acbx} alt=""/>
                                        <img style={{background:"#f2f2f2"}} src={astp} alt=""/>
                                    </Col>
                                </Col>
                                <Col>
                                    <Col>
                                        <img  src={zybx} alt=""/>
                                        <img style={{background:"#f2f2f2"}} src={bc} alt=""/>
                                        <img  src={bm} alt=""/>
                                    </Col>
                                    <Col>
                                        <img style={{background:"#f2f2f2"}} src={jljt} alt=""/>
                                        <img src={cdd} alt=""/>
                                        <img style={{background:"#f2f2f2"}} src={imgB} alt=""/>
                                    </Col>
                                </Col>
                            </Carousel>
                        </div>
                    </Col>
                    <Col style={{marginTop:146,backgroundImage:`url(${banner4})`,height:640}}>
                    </Col>
                </Col>
                <div style={{marginTop:50,height:247,overflow:"hidden"}}>
                    <Col>
                        <Col style={{fontSize:14,color:"#333",textAlign:"left"}} offset={4} md={4}>
                            <Col  className="footTitle">飞马救援</Col>
                            <Col className="footTitle" style={{marginTop:20}}>合作关系</Col>
                            <Col className="footTitle" style={{marginTop:16}}><Link to="/feima/cgal"  rel="noopener noreferrer">成功案例</Link></Col>
                            <Col className="footTitle" style={{marginTop:16}}><Link to="/feima/gywm"  rel="noopener noreferrer">关于我们</Link></Col>
                            <Col className="footTitle" style={{marginTop:16}}><Link to="/feima/lxwm"  rel="noopener noreferrer">联系我们</Link></Col>
                        </Col>
                        <Col  style={{fontSize:14,textAlign:"left",color:"#333"}}  md={4}>
                            <Col className="footTitle" >APP下载</Col>
                            <Col onMouseOver={()=>this.appOver("yidian1")} onMouseOut={()=>this.appOut("yidian1")} style={{cursor:"pointer",color:this.state.yidian1?"#d2a475":"#333",verticalAlign:"middle",marginTop:20,lineHeight:"20px"}}>
                                <Popover placement="top" content={<div style={{height:200,width:200}}><img src={ydjyewm} alt=""/></div>} title="扫描二维码下载">
                                    <img style={{marginRight:10}} src={this.state.yidian1?phone1:phone} alt=""/>下载一点APP
                                </Popover>
                            </Col>
                        </Col>
                        <Col style={{fontSize:14,color:"#333",textAlign:"left"}}  md={4}>
                            <Col className="footTitle" >关注飞马</Col>
                            <Col onMouseOver={()=>this.appOver("wx")} onMouseOut={()=>this.appOut("wx")} style={{cursor:"pointer",color:this.state.wx?"#d2a475":"#333",verticalAlign:"middle",marginTop:20,lineHeight:"20px"}}>
                                <Popover placement="top" content={<div style={{height:200,width:200}}><img src={feimaewm} alt=""/></div>} title="扫描二维码关注">
                                    <img style={{marginRight:10}} src={this.state.wx?wx1:wx} alt=""/>微信公众号
                                </Popover>
                            </Col>
                            <Col onMouseOver={()=>this.appOver("xcx")} onMouseOut={()=>this.appOut("xcx")} style={{cursor:"pointer",color:this.state.xcx?"#d2a475":"#333",verticalAlign:"middle",marginTop:16,lineHeight:"20px"}}>
                                <Popover placement="top" content={<div style={{height:200,width:200}}><img src={xcxewm} alt=""/></div>} title="扫描二维码关注">
                                    <img style={{marginRight:10}} src={this.state.xcx?xcx1:xcx} alt=""/>微信小程序
                                </Popover>
                            </Col>
                        </Col>
                        <Col style={{fontSize:14,color:"#333",textAlign:"left"}} md={4}>
                            <Col className="footTitle">客服服务</Col>
                            <Col onMouseOver={()=>this.appOver("zs1")} onMouseOut={()=>this.appOut("zs1")} style={{cursor:"pointer",color:this.state.zs1?"#d2a475":"#333",verticalAlign:"middle",marginTop:20,lineHeight:"20px"}}>
                                <img style={{marginRight:10}} src={this.state.zs1?tel1:tel} alt=""/>400-070-9995
                                <Col style={{marginLeft:33}}>24小时救援招商热线</Col>
                            </Col>
                            <Col onMouseOver={()=>this.appOver("zs2")} onMouseOut={()=>this.appOut("zs2")} style={{cursor:"pointer",color:this.state.zs2?"#d2a475":"#333",verticalAlign:"middle",marginTop:16,lineHeight:"20px"}}>
                                <img style={{marginRight:10}} src={this.state.zs2?tel1:tel} alt=""/>13306527651
                                <Col style={{marginLeft:33}}>招商热线</Col>
                            </Col>
                        </Col>
                    </Col>
                    <Col style={{clear:"both"}}></Col>
                    <Col style={{lineHeight:"44px",height:44,fontSize:14,textAlign:"center",background:"#333",marginTop:30,color:"#fff"}}>联系地址：杭州下城区费家塘588号7号楼1楼飞马救援 Copyright©杭州必拯汽车服务有限公司 版权所有 ICP许可证号 <a style={{color:"#fff"}} href="https://beian.miit.gov.cn">浙ICP备2021025932号</a></Col>

                </div>
            </div>


        );
    }
}

const mapStateToPorps = state => {
    const { auth } = state.httpData;
    return { auth };
};
const mapDispatchToProps = dispatch => ({
    fetchData: bindActionCreators(fetchData, dispatch),
    receiveData: bindActionCreators(receiveData, dispatch)
});


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(Login));


// WEBPACK FOOTER //
// ./src/components/pages/Login.jsx